module.exports = __webpack_public_path__ + "img/blind-box2.09baddc3.gif";